/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBellOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l5.25 5.249a.75.75 0 01.02.02l16.73 16.73a.75.75 0 11-1.06 1.061l-5.8-5.8a.755.755 0 01-.17.02H3a.75.75 0 01-.422-1.37l.005-.004a3.032 3.032 0 00.288-.26c.208-.21.503-.558.816-1.08.624-1.041 1.33-2.8 1.516-5.586.02-.285.023-.565.027-.866l.006-.352c.008-.427.028-.89.108-1.358.023-.131.049-.261.079-.39L.47 1.53a.75.75 0 010-1.06zM6.75 7.812c-.008.145-.012.295-.016.45l-.004.308c-.005.314-.01.652-.031.98-.201 3.004-.97 4.995-1.726 6.257a8.46 8.46 0 01-.284.443h10.5L6.75 7.812zm4.924-6.563A6.75 6.75 0 0118.75 8v.011c-.026 1.617.177 3.23.604 4.79a.75.75 0 01-1.447.396 18.642 18.642 0 01-.657-5.204 5.25 5.25 0 00-8.164-4.37.75.75 0 01-.832-1.248 6.75 6.75 0 013.42-1.127zM9.894 20.35a.75.75 0 011.025.273 1.25 1.25 0 002.162 0 .75.75 0 011.298.752 2.749 2.749 0 01-4.758 0 .75.75 0 01.273-1.025z'
        />
      </g>
      <defs>
        <clipPath id='bell-off_svg__clip0_126_10464'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgBellOff;
